import React, { useContext } from 'react';
import { GridContext } from '../../context/gridContext';

const HeaderCheckboxRender = (props) => {
  const gridContext = useContext(GridContext);

  const { urlGrid } = props;

  const handleClick = (e) => {
    const { onHeaderCheckboxClick } = gridContext;

    const firstRow = props.api.getDisplayedRowAtIndex(0);
    if (firstRow?.data === undefined) return;

    onHeaderCheckboxClick(e, props);
  };

  // The outer div centres the checkbox inside the header cell (same layout as
  // row CheckboxSelectionRender).  onClick must stay on the span.ant-checkbox
  // because onHeaderCheckboxClick reads e.currentTarget.className to detect
  // whether the header is already checked — that class is toggled on the span
  // by setClassNameHeaderCheckbox, not on the wrapper div.
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <span className={'ant-checkbox ' + urlGrid} onClick={handleClick}>
        <input type='checkbox' className='ant-checkbox-input' value='' readOnly />
        <span className='ant-checkbox-inner'></span>
      </span>
    </div>
  );
};

export default HeaderCheckboxRender;
